import { cloneDeep } from "lodash";

export const applyFilter = (dataArray, filterValue) => {
  return dataArray.filter((item) => {
    return item.LotNumber.toLowerCase().includes(filterValue.toLowerCase());
  });
};

export const applyStageFilter = ({ filter, data }) => {
  const copiedData = cloneDeep(data);
  if (filter && Array.isArray(filter.dataSourceEntry)) {
    return copiedData.filter((row) =>
      filter.dataSourceEntry.includes(row.LotNumber)
    );
  }
  return copiedData; // No filter applied, return all data
};
